<template>
  <div class="mod-sys__commusertraining">

    <el-card shadow="never" class="aui-card--fill">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <!-- <el-form-item>
        <el-input v-model="dataForm.key" placeholder="参数名" clearable></el-input>
      </el-form-item>
      <el-form-item>
          <el-button @click="getDataList()">查询</el-button>
      </el-form-item> -->
    </el-form>
    <div class="search">
      <el-button  plain class="el-button-columnBtn" @click="addUpdate()">{{ $t('add') }}</el-button>
      <el-button  plain class="el-button-columnBtn" @click="exportHandle()">{{ $t('export') }}</el-button>
    </div>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      @selection-change="selectionChangeHandle"
      style="width: 100%;">
      <el-table-column
        type="selection"
        header-align="center"
        align="center"
        width="50">
      </el-table-column>
      <el-table-column
        prop="userTrainingId"
        header-align="center"
        align="center"
        label="用户培训id">
      </el-table-column>
      <el-table-column
        prop="trainingId"
        header-align="center"
        align="center"
        label="培训id">
      </el-table-column>
      <el-table-column
        prop="userId"
        header-align="center"
        align="center"
        label="用户ID">
      </el-table-column>
      <el-table-column
        prop="trainingUrl"
        header-align="center"
        align="center"
        label="培训url">
      </el-table-column>
      <el-table-column
        prop="trainingTitle"
        header-align="center"
        align="center"
        label="培训标题">
      </el-table-column>

        <el-table-column
          fixed="right"
          align="center"
          width="100"
          :label="$t('handle')">
          <template slot-scope="scope">
            <el-dropdown trigger="click" placement="bottom">
              <span class="el-dropdown-link">
                {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="gotoView('view', scope.row.userTrainingId)">{{ $t('view') }}</el-dropdown-item>
                <el-dropdown-item @click.native="gotoView('update', scope.row.userTrainingId)">{{ $t('update') }}</el-dropdown-item>
                <el-dropdown-item @click.native="gotoView('delete', scope.row)">{{ $t('delete') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
    </el-table>
    <el-pagination
      @size-change="pageSizeChangeHandle"
      @current-change="pageCurrentChangeHandle"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    </el-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'

export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/commusertraining/list',
        getDataListIsPage: true,
        deleteURL: '/sys/commusertraining/delete',
        deleteIsBatch: true,
        exportURL: '/sys/commusertraining/export'
      },
      dataForm: {
        key: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false
    }
  },
  components: {
  },
  activated () {
    this.getDataList()
  },
  methods: {
    gotoView (type, id) {
      let query = {}
      let name = 'sys-commusertraining-add-or-update'
      query.userTrainingId = id
      if (type === 'view') {
        name = 'sys-commusertraining-view'
        this.$router.push({
          name: name,
          query: query
        })
      } else if (type === 'update') {
        this.$router.push({
          name: name,
          query: query
        })
      } else if (type === 'delete') {
        this.deleteHandle(id)
      }
    },
    addUpdate (row) {
      let name = 'sys-commusertraining-add-or-update'
      let pkName = (row != null) ? row.userTrainingId : undefined
      let query = {}
      query.userTrainingId = pkName
      this.$router.push({
        name: name,
        query: query
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    }
  }
}
</script>
